/*
 * Wizard field help text component
 * <p>
 *
 * @author lachezar.parvin
 * @author Gallagher Bassett IT
 * @author Copyright (c) 2020 Gallagher Bassett Services, Inc.
 *
 */

import {
  Component,
  Input,
  OnInit,
  ViewEncapsulation
} from '@angular/core';

@Component({
    selector: 'reporter-help-text',
    templateUrl: './help-text.component.html',
    styleUrls: ['./help-text.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class HelpTextComponent implements OnInit {

  @Input() text = '';
  @Input() tooltipClass = '';

  constructor() { }

  ngOnInit(): void {
  }

}
